import Reveal from "@/components/Reveal";

export const Kicker = ({ children, className = "" }) => (
  <span className={`font-mono-lab text-xs md:text-sm tracking-[0.25em] text-[#ff0033] uppercase ${className}`}>
    {children}
  </span>
);

export const PageHeader = ({ kicker, title, intro }) => (
  <section className="pt-36 md:pt-44 pb-12 md:pb-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <Reveal direction="up">
      <Kicker>{kicker}</Kicker>
      <h1 className="font-heading text-5xl sm:text-6xl md:text-8xl uppercase tracking-tight leading-none text-white mt-4">
        {title}
      </h1>
      {intro && (
        <p className="text-neutral-400 text-base md:text-lg max-w-2xl mt-6 leading-relaxed">
          {intro}
        </p>
      )}
    </Reveal>
  </section>
);
